module.exports = __webpack_public_path__ + "static/media/010-folder-2.c80f597c.svg";